export default __webpack_public_path__ + "static/media/user-thomas.dca89ddb.png";